module.exports = __webpack_public_path__ + "img/web-slm.9e240e66.jpg";